import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import EMentor from "../components/EMentor";
import Instructions from "../components/Instructions";

export default function ConstructedResponse(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />

      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Question:
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className={`${tl} m-0 wysiwyg`}
                  dir={dir}
                  dangerouslySetInnerHTML={{ __html: data.core.prompt }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper elevation={0} variant="outlined" square className="p-16 m-16">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Feedback Response:
                </Typography>
                <Divider className="my-16" />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  className={`${tl} m-0 wysiwyg`}
                  dir={dir}
                  dangerouslySetInnerHTML={{ __html: data.core.response }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {data.eMentor.length !== 0 && (
        <EMentor
          eMentor={data.eMentor}
          tl={tl}
          dir={dir}
          componentCommentsCount={componentCommentsCount}
        />
      )}
    </div>
  );
}
